import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { onAuthStateChanged, type User } from "firebase/auth";
import { auth, isFirebaseConfigured } from "../firebase";
import { AuthPanel } from "../components/AuthPanel";
import { AthleteView } from "../components/AthleteView";
import { CoachView } from "../components/CoachView";

/** Coach or athlete, the same account either way: the two doors just decide what you land on. */
type Door = "athlete" | "coach";

export function Workout() {
  const [user, setUser] = useState<User | null>(null);
  const [ready, setReady] = useState(false);
  const [door, setDoor] = useState<Door | null>(null);

  useEffect(() => {
    if (!isFirebaseConfigured) {
      setReady(true);
      return;
    }
    return onAuthStateChanged(auth, (next) => {
      setUser(next);
      setReady(true);
    });
  }, []);

  if (!isFirebaseConfigured) {
    return (
      <main className="shell centered">
        <Header />
        <p className="notice">
          No Firebase web config yet. Copy <code>.env.example</code> to <code>.env</code> and fill
          it in with the values of a Web app registered in the Firebase console.
        </p>
      </main>
    );
  }

  if (!ready) return <main className="shell" />;

  if (!user) {
    return (
      <main className="shell centered">
        <Header />
        {door === null ? (
          <section className="card narrow">
            <h2>Who are you here as?</h2>
            <button onClick={() => setDoor("athlete")}>Athlete login</button>
            <button className="ghost" onClick={() => setDoor("coach")}>
              Coach login
            </button>
          </section>
        ) : (
          <AuthPanel onBack={() => setDoor(null)} />
        )}
      </main>
    );
  }

  return (
    <main className="shell">
      <Header signedIn />
      {/* Whoever signed in may be both; the door they came through decides what they see. */}
      {door === "coach" ? <CoachView coach={user} /> : <AthleteView user={user} />}
      <button className="ghost" onClick={() => setDoor(door === "coach" ? "athlete" : "coach")}>
        {door === "coach" ? "Switch to my own plans" : "Switch to coaching"}
      </button>
    </main>
  );
}

function Header({ signedIn = false }: { signedIn?: boolean }) {
  return (
    <header className="header">
      <Link className="wordmark link" to="/app">
        Gymquisition
      </Link>
      <span className="tag">Workout</span>
      {signedIn && (
        <button className="ghost" onClick={() => auth.signOut()}>
          Log out
        </button>
      )}
    </header>
  );
}
